import React, { useState, useContext, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import * as firebase from "firebase/app";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import OseelaIcon from "./statics/oseelaSquare.png";
import { UserContext } from "./UserContext";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    width: 80,
    height: 80,
    "& img": {
      width: "100%",
      height: "100%"
    }
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    background: "rgb(11,31,92)",
    background:
      "linear-gradient(90deg, rgba(11,31,92,1) 0%, rgba(63,155,214,1) 100%);"
  }
}));

export default function SignUp(props) {
  const classes = useStyles();
  const { user, setUser } = useContext(UserContext);
  const [nick, setNick] = useState("");
  const [email, setEmail] = useState("");
  const [age, setAge] = useState("");
  const [pass, setPass] = useState("");
  const [spinner, setSpinner] = useState("none");
  const [error, setError] = useState({ show: "none", msg: "" });

  const inputHandler = e => {
    switch (e.target.id) {
      case "UserName":
        setNick(e.target.value);
        break;
      case "Age":
        setAge(e.target.value);
        break;
      case "email":
        setEmail(e.target.value);
        break;
      case "password":
        setPass(e.target.value);
        break;
    }
  };

  const submitHandler = e => {
    e.preventDefault();
    setError({ show: "none", msg: "" });
    setSpinner("block");
    if (Number(age)) {
      firebase
        .database()
        .ref("/Pemails")
        .once("value")
        .then(function(snapshot) {
          return Object.values(snapshot.val());
        })
        .then(res => {
          if (res.includes(email)) {
            firebase
              .auth()
              .createUserWithEmailAndPassword(email, pass)
              .then(res => {
                const uid = res.user.uid;
                firebase
                  .database()
                  .ref("Users/" + uid)
                  .set({
                    _age_as_number: age,
                    _nickname: nick,
                    _mail: email
                  })
                  .then(() => {
                    setUser({
                      name: nick,
                      age: age,
                      email: email
                    });
                  });
              })
              .catch(error => {
                console.log(error);
                setSpinner("none");
                setError({ show: "block", msg: error.message });

                setPass("");
              });
          } else {
            setSpinner("none");
            setError({ show: "block", msg: "Cant Sign up with that email" });

            setPass("");
          }
        });
    } else {
      setSpinner("none");
      setError({ show: "block", msg: "Age must be a number" });

      setPass("");
    }
  };
  useEffect(() => {
    if (props.user.name) {
      props.history.push("map");
    }
  }, [user]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar src={OseelaIcon} className={classes.avatar} />
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <form onSubmit={submitHandler} className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={10} sm={10}>
              <TextField
                autoComplete="off"
                name="UserName"
                value={nick}
                onChange={inputHandler}
                required
                fullWidth
                id="UserName"
                label="User Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={2} sm={2}>
              <TextField
                autoComplete="off"
                name="Age"
                required
                fullWidth
                value={age}
                onChange={inputHandler}
                id="Age"
                label="Age"
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                id="email"
                label="Email Address"
                value={email}
                onChange={inputHandler}
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                value={pass}
                onChange={inputHandler}
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign Up
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="/login" variant="body2">
                Already have an account? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
        <div style={{ display: error.show, marginTop: "2%" }}>
          <Typography variant="caption" color="error">
            {error.msg}
          </Typography>
        </div>
        <div style={{ display: spinner, marginTop: "2%" }}>
          <CircularProgress size={40} />
        </div>
      </div>
    </Container>
  );
}
